(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wb3-product-rail"] && !Shopify.designMode) return;
  try {
    
  const initializeWB3ProductRail = (root = document) => {
    root.querySelectorAll('.wb3-products__rail:not([data-drag-ready])').forEach((rail) => {
      rail.dataset.dragReady = 'true';
      let dragging = false;
      let moved = false;
      let startX = 0;
      let startScroll = 0;
      const edgePreviousButton = rail.closest('.wb3-products').querySelector('.wb3-products__edge-button--prev');
      const edgeNextButton = rail.closest('.wb3-products').querySelector('.wb3-products__edge-button--next');

      const updateButtons = () => {
        const minimumScroll = Number.parseFloat(getComputedStyle(rail).paddingLeft) || 0;
        const maxScroll = rail.scrollWidth - rail.clientWidth;
        edgePreviousButton.disabled = rail.scrollLeft <= minimumScroll + 2;
        edgeNextButton.disabled = rail.scrollLeft >= maxScroll - 2;
      };

      const scrollOneProduct = (direction) => {
        const card = rail.querySelector('.wb3-products__card');
        const gap = Number.parseFloat(getComputedStyle(rail).columnGap) || 0;
        const minimumScroll = Number.parseFloat(getComputedStyle(rail).paddingLeft) || 0;
        const maximumScroll = rail.scrollWidth - rail.clientWidth;
        const distance = card.getBoundingClientRect().width + gap;
        rail.scrollLeft = Math.min(maximumScroll, Math.max(minimumScroll, rail.scrollLeft + direction * distance));
        updateButtons();
      };

      edgePreviousButton.addEventListener('click', () => scrollOneProduct(-1));
      edgeNextButton.addEventListener('click', () => scrollOneProduct(1));
      rail.addEventListener('scroll', updateButtons, { passive: true });
      updateButtons();

      rail.addEventListener('mousedown', (event) => {
        if (event.button !== 0 || window.innerWidth < 1000) return;
        dragging = true;
        moved = false;
        startX = event.clientX;
        startScroll = rail.scrollLeft;
        rail.classList.add('is-dragging');
      });

      window.addEventListener('mousemove', (event) => {
        if (!dragging) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 4) moved = true;
        rail.scrollLeft = startScroll - distance;
        event.preventDefault();
      });

      const stopDragging = () => {
        if (!dragging) return;
        dragging = false;
        rail.classList.remove('is-dragging');
      };

      window.addEventListener('mouseup', stopDragging);
      window.addEventListener('blur', stopDragging);
      rail.addEventListener('click', (event) => {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }, true);
    });
  };

  initializeWB3ProductRail();
  document.addEventListener('shopify:section:load', (event) => initializeWB3ProductRail(event.target));

  } catch(e) { console.error(e); }
})();
})();
